import { TableCell, styled } from '@mui/material';

interface DocumentationTableCellProps {
  index?: number;
}

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'index',
})<DocumentationTableCellProps>(({ theme, index }) => {
  const palette = theme.vars.palette;
  return {
    ':first-of-type': { borderLeft: 0 },

    align: 'center',
    borderBottom: `1px solid ${palette.divider}`,
    borderLeft: `1px solid ${palette.divider}`,
    fontWeight: 500,
    backgroundColor:
      (index || index === 0) && index % 2 === 0 ? palette.grey[50] : palette.background.paper,
  };
});

export const StyledKeyTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'hasBorderLeft' && prop !== 'index',
})<{ index: number }>(({ theme, index }) => {
  const palette = theme.vars.palette;
  return {
    borderBottom: `1px solid ${palette.divider}`,
    paddingLeft: theme.spacing(6),
    backgroundColor: index % 2 === 0 ? palette.grey[50] : palette.background.paper,
  };
});

export const StyledHeadTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'index',
})<DocumentationTableCellProps>(({ theme, index }) => ({
  ':first-of-type': { borderLeft: 0 },

  align: 'center',
  borderBottom: `1px solid ${theme.vars.palette.divider}`,
  borderLeft: `1px solid ${theme.vars.palette.divider}`,
  fontWeight: 600,
  backgroundColor: theme.vars.palette.grey.A100,
}));
